import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Datepicker = ({ selectedDate, onDateChange, className,placeholder }) => {
  return (
    <DatePicker
      selected={selectedDate} 
      onChange={(date) => onDateChange(date)}
      className={className}
      placeholderText={placeholder}
      showMonthDropdown
      showYearDropdown
      dateFormat="dd/MM/yyyy"
    />
  );
};

export default Datepicker;
